<template>
    <div class="mt-2">

        <v-container>
            <v-layout row wrap class="justify-space-around">
                <v-flex xs12 sm12 md9 >
                    <v-card class="mx-2">
                        <v-card-text>
                            <div>
                                <h1>Les amendes et retraits de point pour les excès de vitesse</h1>
                                <p>Un excès de vitesse se définit par le dépassement de la vitesse maximale qui est
                                    autorisée sur une portion de route. Le contrevenant se verra infliger une sanction
                                    proportionnelle à l’importance de son excès de vitesse. Elle variera aussi selon s’il
                                    circulait sur une autoroute, une route ou en ville au moment de l’infraction.
                                </p>
                                <p>
                                    Il faut bien noter que l’on appelle vitesse maximale autorisée la vitesse que le
                                    conducteur ne doit pas dépasser sous peine de commettre un excès de vitesse.
                                    Celle-ci correspond à des conditions de circulation optimales, c’est-à-dire une
                                    fluidité du trafic, un véhicule en parfait état de fonctionnement… Ainsi, le véhicule
                                    ne circule pas forcément à la vitesse maximale autorisée.
                                </p>
                            </div>

                            <div>
                                <h2>La majorité des excès de vitesse sont de moins de 20 km/h</h2>
                                <p>
                                    Parmi les millions de contraventions enregistrées chaque année par les radars, les excès de
                                    vitesse les plus courant n’excèdent pas 20 km/heure.
                                </p>
                                <p>
                                    Ce type d’excès est sanctionné par le retrait d’1 point sur le permis du conducteur.
                                </p>
                                <p>
                                    L’amende ne sera pas la même si l’excès de vitesse a lieu hors ou dans une agglomération.
                                </p>
                                <p>
                                    Un excès de vitesse commis dans une agglomération correspond à une amende de classe 4.
                                    Un dépassement identique commis hors d’une agglomération engendre une amende de
                                    classe 3.
                                </p>
                                <p>
                                    En l’absence d’effraction supplémentaire, le conducteur récupérera le point retiré
                                    automatiquement au bout de 6 mois.
                                </p>
                            </div>

                            <div>
                                <h2>Le barème des infractions pour excès de vitesse</h2>
                                <p>
                                    Tout excès de vitesse se verra sanctionné par une amende et un retrait de points, tel que
                                    prévu par le code de la route. Les sanctions sont proportionnelles à la gravité du
                                    dépassement commis.
                                </p>
                                <h3>Les infractions pour les excès de vitesse en ville :</h3>
                                <ul>
                                    <li>Inférieur 20 km/h :</li>
                                    <ul>
                                        <li>Retrait d’1 point (récupéré automatiquement au bout de 6 mois)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>
                                    <li>Entre 20 km/h et 29 km/h</li>
                                    <ul>
                                        <li>Retrait de 2 points (récupérés automatiquement au bout de 3 ans)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>
                                    <li>Entre 30 km/h et 39 km/h</li>
                                    <ul>
                                        <li>Retrait de 3 points (récupérés automatiquement au bout de 3 ans)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>
                                    <li>Entre 40 km/h et 49 km/h</li>
                                    <ul>
                                        <li>Retrait de 4 points (récupérés automatiquement au bout de 3 ans)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>
                                    <p>Les points ne sont récupérés qu’en l’absence de nouvelle infraction dans ce délai</p>
                                </ul>
                            </div>

                            <div>
                                <h2>Les infractions pour excès de vitesse hors agglomération</h2>
                                <ul>
                                    <li>Inférieur 20 km/h :</li>
                                    <ul>
                                        <li>Retrait d’1 point (récupéré automatiquement au bout de 6 mois)</li>
                                        <li>Amende de 68 euros</li>
                                    </ul>

                                    <li>Inférieur à 30 km/h :</li>
                                    <ul>
                                        <li>Retrait de 2 points (récupérés automatiquement au bout de 3 ans)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>

                                    <li>Inférieur à 40 km/h :</li>
                                    <ul>
                                        <li>Retrait de 3 points (récupérés automatiquement au bout de 3 ans)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>

                                    <li>Inférieur à 50 km/h :</li>
                                    <ul>
                                        <li>Retrait de 4 points (récupérés automatiquement au bout de 6 mois)</li>
                                        <li>Amende de 135 euros</li>
                                    </ul>

                                    <li>Supérieur à 50 km/h :</li>
                                    <ul>
                                        <li>Retrait de 6 points (récupéré automatiquement au bout de 3 ans)</li>
                                        <li>Amende de 1 500 euros</li>
                                        <li>Les sanctions suivantes peuvent être imposées par le juge :</li>
                                        <ul>
                                            <li>Permis suspendus jusqu’à un maximum de 3 ans</li>
                                            <li>Participation obligatoire à un stage de sensibilisation à la sécurité
                                                routière</li>
                                            <li>Véhicule confisqué</li>
                                            <li>Conduite de certains véhicules interdite</li>
                                        </ul>
                                    </ul>
                                </ul>
                                <p>
                                    Les forces de l’ordre peuvent, depuis le 20 novembre 2016, immobilier le véhicule en
                                    fourrière pendant 7 jours lors de la verbalisation d’un grand excès de vitesse.
                                </p>
                                <p>
                                    S’il y a récidive, l’infraction se transforme alors en délit. Le conducteur est renvoyé devant le
                                    tribunal correctionnel.
                                </p>
                            </div>

                            <div>
                                <h2>Contrôle de la vitesse et la tolérance</h2>
                                <p>
                                    Il existe différentes façons de contrôler la vitesse d’un véhicule en circulation. Les routes de
                                    France comportent diverses sortes de radars :
                                </p>
                                <ul>
                                    <li>Automatique : ce radar fixe permet de contrôler la vitesse instantanée du véhicule</li>
                                    <li>Tronçon : deux caméras espacées sont couplées par une un détecteur de vitesse. Ce
                                        radar calcule la vitesse moyenne d’un véhicule sur une portion de route. Son objectif
                                        est d’éviter les dépassements de vitesse entre 2 radars dont le conducteur connaît
                                        les emplacements.</li>
                                    <li> Double face : l’identification du véhicule est améliorée car il est photographié à
                                        l’avant et à l’arrière.</li>
                                    <li>Embarqué : Il se trouve dans une voiture banalisée et cible surtout les grands excès
                                        de vitesse. Il possède un flash infra-rouge invisible.</li>
                                    <li>Multi-infractions : ils permettent de contrôler le bon respect des feux de signalisation
                                        ainsi que la vitesse du véhicule au moment où il franchit le feu vert.</li>
                                    <li> Pédagogique : la vitesse du véhicule est affichée sur un panneau qui informe ainsi le
                                        conducteur de l’allure à laquelle il circule. Il ne déclenche aucune sanction.</li>
                                    <li>Leurre : le conducteur ne sait pas s’il fonctionne ou non.</li>
                                </ul>
                                <p>
                                    Une tolérance de 5 km/h s’applique à toute mesure de la vitesse d’un véhicule. Ainsi, pour
                                    un véhicule contrôlé à 85 km/h sur route, on retiendra la vitesse de 80 km/h.
                                </p>
                                <p>
                                    La présence de radars automatiques est indiquée par des panneaux depuis le 1 er mars 2017.
                                    Ils permettent de rappeler la vitesse limite autorisée et d’éviter toute erreur de jugement.
                                </p>
                                <p>
                                    Les radars mobiles embarqués par des sociétés privées sont actuellement testés. Un appel
                                    d’offres a été lancé par le Ministère de l’Intérieur afin que cette mission ne soit pas confiée
                                    aux forces de l’ordre, afin de les décharger en partie de cette tâche, mais à des sociétés
                                    privées.
                                </p>
                            </div>

                            <div>
                                <h2>Comment payer une amende reçue pour excès de vitesse</h2>
                                <p>
                                    En cas de contrôle effectué directement par les forces de l’ordre, le conducteur se voit
                                    remettre une carte-lettre. Il s’agit d’une carte de paiement et d’un avis de contravention. Le
                                    contrôle automatisé, quant à lui, déclenche l’envoi d’un avis de contravention que le titulaire
                                    de la carte grise reçoit directement à son domicile.
                                </p>
                                <p>
                                    L’amende peut être payée en ligne ou avec un timbre dématérialisé. Celui-ci se trouve dans
                                    les bureaux de tabac qui bénéficient de l’agréement « Paiement électronique des
                                    amendes ». Afin de procéder à son règlement, il suffit de présenter votre talon de paiement.
                                    Vous vous recevrez en échange un justificatif de paiement.
                                </p>
                            </div>

                            <div>
                                <h2>Quels sont les délais pour régler une amende</h2>
                                <ul>
                                    <li>Amende minorée : 15 jours en chèque ou espèce / 30 jours par internet, téléphone
                                        ou timbre dématérialisé</li>
                                    <li>Amende forfaitaire : 45 jours en chèque ou espèces / 60 jours par internet, téléphone
                                        ou timbre dématérialisé</li>
                                </ul>
                                <p>Si l’amende n’est pas réglée dans un délai de 45 jours, elle sera majorée.</p>
                                <p>
                                    Vous disposez d’un délai de 45 jours afin de contester toute amende forfaitaire pour excès
                                    de vitesse, et de 30 jours pour un pv majoré.
                                </p>
                            </div>

                            <div>
                                <h2>Petit rappel des limites de vitesse</h2>
                                <p>Autoroute : 130 km/h / 110 km/h par mauvais temps</p>
                                <p>Voie rapide : 110 km/h / 100 km/h par mauvais temps</p>
                                <p>Route : 80 km/h</p>
                                <p>En agglomération : en ville : 50 km/h</p>
                                <p>Accès limité aux riverains : 70 km/h</p>
                                <p>Périphérique parisien : 70 km/h</p>
                                <p>Visibilité inférieure à 50 mètres : 50 km/h quelle que soit le type de route emprunté.</p>
                            </div>

                            <div>
                                <h2>Excès de vitesse et période probatoire</h2>
                                <p>Les élèves conducteurs ainsi que les détenteurs de permis probatoires sont dans l’obligation
                                    de respecter des limites de vitesse particulières :</p>
                                <ul>
                                    <li>Autoroutes : 110 km/h</li>
                                    <li>Portions d’autoroutes à 110 km/h et routes comportant 2 fois 2 voies avec terreplein
                                        central : 100 km/h</li>
                                    <li>Routes hors agglomération : 80 km/h sur les autres routes</li>
                                </ul>
                                <p>
                                    Les excès de vitesse commis en période probatoire engendrent les mêmes sanctions que
                                    les autres excès de vitesse.
                                </p>
                                <p>
                                    Il est recommandé au jeunes conducteurs détenteurs d’un permis probatoire d’être
                                    particulièrement vigilant. En effet, s’ils commettent un dépassement de plus de 50km/h,
                                    ils encourent, durant la première année, une invalidation de leur permis de conduire. Ils
                                    ne pourront pas suivre de stage de récupération de points.
                                </p>
                                <p>
                                    Les jeunes conducteurs qui perdent au moins 3 points en période probatoire doivent
                                    suivre obligatoirement un stage.
                                </p>
                            </div>

                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 sm12 md3>
                    <v-card class="mx-2">
                        <v-card-text>
                            <RightAsideInfractions></RightAsideInfractions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <Footer />
    </div>
</template>

<script>
    import RightAsideInfractions from '@/components/RightAsideInfractions'
    import Footer from '@/components/Footer'

    export default {
        name: "stage-recuperation-points",
        components: {
            RightAsideInfractions,
            Footer
        }
    }
</script>

<style>
    .highlighted {
        background: #ffedf5;
        border-radius: 10px;
        color: #7a0439;
        font-size: 18px;
        font-weight: 800;
        padding: 10px;
    }

    .highlighted p {
        font-size: 18px;
    }

    ul li {
        list-style-type: circle;
        margin: 10px 0 10px 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        color: black;
    }

    p {
        font-size: 16px;
    }
</style>
